// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS totalment aïllat del portal mòbil /Control_Horari. No compartir
   classes amb dashboard.css ni amb la resta de l'ERP (CURRENT_TASK.md
   §5.2: "no barrejar amb l'ERP general"). Si mai cal revertir aquest
   portal, n'hi ha prou en deixar d'importar aquest fitxer i els
   components de pages/ControlHorari/. */

:root {
  --ch-blau: #0099cc;
  --ch-blau-fosc: #007399;
  --ch-taronja: #ff9933;
  --ch-taronja-fosc: #cc7a29;
  --ch-fosc: #1f3a4d;
  --ch-gris: #64748a;
  --ch-gris-clar: #e4e9ef;
  --ch-vermell: #c0392b;
  --ch-verd: #2e8b57;
}

.ch-app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  color: var(--ch-fosc);
  background-size: cover;
  background-position: center top;
  background-attachment: fixed;
}

/* ---------- Capçalera ---------- */

.ch-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: calc(env(safe-area-inset-top, 0px) + 10px) 12px 10px;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid var(--ch-gris-clar);
  position: sticky;
  top: 0;
  z-index: 20;
}

.ch-header-titol {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 15px;
  color: var(--ch-fosc);
  flex: 1 1;
  justify-content: center;
}

.ch-logo {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.ch-boto-icona {
  border: none;
  background: transparent;
  color: var(--ch-blau);
  font-size: 18px;
  padding: 6px;
  line-height: 1;
  cursor: pointer;
}

.ch-header-dreta {
  display: flex;
  align-items: center;
  gap: 2px;
}

.ch-estat-connexio {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: var(--ch-gris);
  white-space: nowrap;
}

.ch-estat-connexio.ch-online {
  color: var(--ch-verd);
}

.ch-estat-connexio.ch-offline {
  color: var(--ch-gris);
}

.ch-badge-pendents {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--ch-taronja);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  margin-left: 4px;
}

/* ---------- Menú lateral ---------- */

.ch-menu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 30, 40, 0.45);
  z-index: 30;
  display: flex;
  justify-content: flex-start;
}

.ch-menu {
  width: min(260px, 80vw);
  height: 100%;
  background: #fff;
  padding: calc(env(safe-area-inset-top, 0px) + 16px) 16px 16px;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
}

.ch-menu-capcalera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  margin-bottom: 16px;
}

.ch-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: transparent;
  padding: 12px 8px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
}

.ch-menu-item-perill {
  color: var(--ch-vermell);
}

.ch-menu-item:hover {
  background: var(--ch-gris-clar);
}

/* ---------- Contingut / navegació inferior ---------- */

.ch-contingut {
  flex: 1 1;
  padding: 14px 14px calc(env(safe-area-inset-bottom, 0px) + 88px);
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.ch-nav-inferior {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: rgba(255, 255, 255, 0.97);
  border-top: 1px solid var(--ch-gris-clar);
  padding: 6px 0 calc(env(safe-area-inset-bottom, 0px) + 6px);
  z-index: 20;
}

.ch-nav-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  color: var(--ch-gris);
  text-decoration: none;
  padding: 4px 0;
}

.ch-nav-item svg {
  font-size: 18px;
}

.ch-nav-item.actiu {
  color: var(--ch-blau);
  font-weight: 700;
}

/* ---------- Login ---------- */

.ch-login-pantalla {
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.ch-login-caixa {
  width: 100%;
  max-width: 360px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 32px 24px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  text-align: center;
}

.ch-login-logo {
  width: 56px;
  height: 56px;
  margin-bottom: 8px;
}

.ch-login-titol {
  margin: 0 0 4px;
  font-size: 22px;
  color: var(--ch-fosc);
}

.ch-login-subtitol {
  margin: 0 0 20px;
  color: var(--ch-gris);
  font-size: 13px;
}

.ch-login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  text-align: left;
}

.ch-camp {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ch-fosc);
}

.ch-camp input {
  padding: 11px 12px;
  border: 1px solid var(--ch-gris-clar);
  border-radius: 10px;
  font-size: 15px;
}

.ch-camp input:focus {
  outline: none;
  border-color: var(--ch-blau);
}

.ch-login-nota {
  margin-top: 18px;
  font-size: 11px;
  color: var(--ch-gris);
}

/* ---------- Botons ---------- */

.ch-boto-principal {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.ch-boto-principal:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ch-boto-blau {
  background: var(--ch-blau);
}

.ch-boto-blau:not(:disabled):hover {
  background: var(--ch-blau-fosc);
}

.ch-boto-taronja {
  background: var(--ch-taronja);
}

.ch-boto-taronja:not(:disabled):hover {
  background: var(--ch-taronja-fosc);
}

.ch-boto-fosc {
  background: var(--ch-fosc);
}

.ch-boto-secundari {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--ch-blau);
  border-radius: 12px;
  background: transparent;
  color: var(--ch-blau);
  font-weight: 700;
  cursor: pointer;
  margin-top: 8px;
}

/* ---------- Pantalla Ajuda ---------- */

.ch-boto-tornar {
  width: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 12px;
  padding: 8px 14px;
}

.ch-ajuda-titol {
  margin-bottom: 12px;
}

.ch-ajuda-paragraf {
  margin: 0 0 8px;
}

.ch-ajuda-paragraf:last-child {
  margin-bottom: 0;
}

.ch-ajuda-llista {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  color: var(--ch-gris);
  line-height: 1.5;
}

.ch-ajuda-llista li {
  margin-bottom: 6px;
}

.ch-ajuda-llista li:last-child {
  margin-bottom: 0;
}

/* ---------- Pantalla Inici ---------- */

.ch-salutacio {
  margin: 4px 0 0;
  font-size: 15px;
  color: var(--ch-gris);
}

.ch-data-llarga {
  margin: 2px 0 6px;
  font-size: 13px;
  color: var(--ch-gris);
}

.ch-rellotge {
  margin: 0 0 4px;
  font-size: 40px;
  font-weight: 700;
  color: var(--ch-blau);
  letter-spacing: 1px;
}

.ch-rellotge-petit {
  margin: 0 0 18px;
  font-size: 28px;
  font-weight: 700;
  color: var(--ch-blau);
}

.ch-subestat {
  margin: 0 0 16px;
  font-size: 14px;
  color: var(--ch-gris);
}

.ch-subestat-blau {
  color: var(--ch-blau-fosc);
  font-weight: 600;
}

.ch-subestat-taronja {
  color: var(--ch-taronja-fosc);
  font-weight: 600;
}

.ch-temps-efectiu {
  margin: -10px 0 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ch-fosc);
}

.ch-temps-restant {
  color: var(--ch-gris);
  font-weight: 600;
}

.ch-temps-extra {
  color: var(--ch-taronja-fosc);
  font-weight: 600;
}

.ch-text-retallat {
  color: var(--ch-taronja-fosc);
  margin-top: 2px;
}

.ch-targeta {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid var(--ch-gris-clar);
  border-radius: 14px;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.ch-targeta-capcalera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  color: var(--ch-fosc);
  margin-bottom: 8px;
}

.ch-etiqueta-estat {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 999px;
}

.ch-etiqueta-oberta {
  background: rgba(255, 153, 51, 0.15);
  color: var(--ch-taronja-fosc);
}

.ch-etiqueta-tancada {
  background: rgba(0, 153, 204, 0.12);
  color: var(--ch-blau-fosc);
}

.ch-fila-event {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 0;
  border-top: 1px solid var(--ch-gris-clar);
}

.ch-fila-event:first-of-type {
  border-top: none;
}

.ch-icona-cercle {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}

.ch-icona-cercle.ch-icona-petita {
  width: 26px;
  height: 26px;
  font-size: 11px;
}

.ch-icona-blau {
  background: var(--ch-blau);
}

.ch-icona-taronja {
  background: var(--ch-taronja);
}

.ch-icona-fosc {
  background: var(--ch-fosc);
}

.ch-fila-event-text {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  flex: 1 1;
}

.ch-fila-event-text strong {
  font-size: 14px;
}

.ch-ubicacio {
  color: var(--ch-gris);
  font-size: 11px;
}

.ch-hora-dreta {
  font-size: 13px;
  font-weight: 600;
  color: var(--ch-gris);
  white-space: nowrap;
}

.ch-text-suau {
  color: var(--ch-gris);
  font-size: 13px;
  margin: 4px 0;
}

.ch-accio-principal {
  margin-top: 8px;
}

.ch-avis-offline {
  font-size: 12px;
  color: var(--ch-gris);
  background: var(--ch-gris-clar);
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 10px;
}

.ch-avis-pendents {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  color: var(--ch-taronja-fosc);
  background: rgba(255, 153, 51, 0.12);
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 10px;
}

.ch-boto-sincronitzar {
  border: 1px solid var(--ch-taronja);
  background: #fff;
  color: var(--ch-taronja-fosc);
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.ch-boto-sincronitzar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ch-fila-event.ch-pendent {
  opacity: 0.75;
}

.ch-etiqueta-pendent {
  font-size: 10px;
  font-weight: 700;
  color: var(--ch-taronja-fosc);
  background: rgba(255, 153, 51, 0.15);
  border-radius: 999px;
  padding: 2px 7px;
  margin-left: 6px;
  white-space: nowrap;
}

.ch-etiqueta-error {
  font-size: 10px;
  font-weight: 700;
  color: var(--ch-vermell);
  background: rgba(192, 57, 43, 0.12);
  border-radius: 999px;
  padding: 2px 7px;
  margin-left: 6px;
  white-space: nowrap;
}

.ch-avis-error {
  background: rgba(192, 57, 43, 0.1);
  color: var(--ch-vermell);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ch-carregant {
  text-align: center;
  color: var(--ch-gris);
  padding: 40px 0;
  font-size: 14px;
}

/* ---------- Pantalla Fitxar ---------- */

.ch-pregunta {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin: 8px 0 2px;
}

.ch-subpregunta {
  text-align: center;
  color: var(--ch-gris);
  font-size: 13px;
  margin: 0 0 4px;
}

.ch-llista-accions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
}

.ch-accio-principal .ch-boto-principal {
  min-height: 52px;
}

.ch-llista-pausa {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0 16px;
}

.ch-opcio-pausa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  border: 1.5px solid var(--ch-gris-clar);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95);
  cursor: pointer;
  text-align: left;
}

.ch-opcio-pausa.seleccionada {
  border-color: var(--ch-blau);
  background: rgba(0, 153, 204, 0.06);
}

.ch-opcio-pausa.seleccionada svg {
  color: var(--ch-blau);
}

.ch-opcio-pausa-text {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  color: var(--ch-gris);
}

.ch-opcio-pausa-text strong {
  color: var(--ch-fosc);
  font-size: 14px;
}

/* ---------- Pantalla Històric ---------- */

.ch-historic-navegacio {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin-bottom: 14px;
}

.ch-historic-mes {
  font-weight: 700;
  font-size: 15px;
  min-width: 130px;
  text-align: center;
}

/* ---------- Pantalla Registres (§8) ---------- */

.ch-registres-periode {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
}

.ch-registres-periode label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: var(--ch-gris);
  flex: 1 1;
}

.ch-registres-periode input {
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid var(--ch-gris-clar);
  font-size: 13px;
}

.ch-registres-totals {
  display: flex;
  justify-content: space-around;
  gap: 10px;
}

.ch-registres-total {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ch-registres-total-valor {
  font-size: 15px;
  font-weight: 700;
  color: var(--ch-fosc);
}

.ch-registres-total-etiqueta {
  font-size: 11px;
  color: var(--ch-gris);
}

.ch-registres-pendent {
  color: var(--ch-vermell);
}

.ch-registres-excedent {
  color: var(--ch-blau);
}

.ch-registres-dia {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--ch-gris-clar);
}

.ch-registres-dia:last-child {
  border-bottom: none;
}

.ch-registres-dia-data {
  font-weight: 700;
  font-size: 13px;
  color: var(--ch-fosc);
  min-width: 90px;
}

.ch-registres-dia-linies {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 12px;
  color: var(--ch-gris);
}

.ch-registres-saldo-positiu {
  color: var(--ch-verd);
  font-weight: 700;
}

.ch-registres-saldo-negatiu {
  color: var(--ch-vermell);
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ControlHorari/controlhorari.css"],"names":[],"mappings":"AAAA;;;;wCAIwC;;AAExC;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gGAAgG;EAChG,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,6DAA6D;EAC7D,qCAAqC;EACrC,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uCAAuC;;AAEvC;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,yDAAyD;;AAEzD;EACE,SAAO;EACP,gEAAgE;EAChE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,yCAAyC;EACzC,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gCAAgC;;AAEhC;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,yCAAyC;;AAEzC;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yCAAyC;;AAEzC;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA,0CAA0C;;AAE1C;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,4CAA4C;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB","sourcesContent":["/* CSS totalment aïllat del portal mòbil /Control_Horari. No compartir\n   classes amb dashboard.css ni amb la resta de l'ERP (CURRENT_TASK.md\n   §5.2: \"no barrejar amb l'ERP general\"). Si mai cal revertir aquest\n   portal, n'hi ha prou en deixar d'importar aquest fitxer i els\n   components de pages/ControlHorari/. */\n\n:root {\n  --ch-blau: #0099cc;\n  --ch-blau-fosc: #007399;\n  --ch-taronja: #ff9933;\n  --ch-taronja-fosc: #cc7a29;\n  --ch-fosc: #1f3a4d;\n  --ch-gris: #64748a;\n  --ch-gris-clar: #e4e9ef;\n  --ch-vermell: #c0392b;\n  --ch-verd: #2e8b57;\n}\n\n.ch-app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  color: var(--ch-fosc);\n  background-size: cover;\n  background-position: center top;\n  background-attachment: fixed;\n}\n\n/* ---------- Capçalera ---------- */\n\n.ch-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: calc(env(safe-area-inset-top, 0px) + 10px) 12px 10px;\n  background: rgba(255, 255, 255, 0.92);\n  border-bottom: 1px solid var(--ch-gris-clar);\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n\n.ch-header-titol {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 700;\n  font-size: 15px;\n  color: var(--ch-fosc);\n  flex: 1;\n  justify-content: center;\n}\n\n.ch-logo {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n}\n\n.ch-boto-icona {\n  border: none;\n  background: transparent;\n  color: var(--ch-blau);\n  font-size: 18px;\n  padding: 6px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.ch-header-dreta {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.ch-estat-connexio {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: var(--ch-gris);\n  white-space: nowrap;\n}\n\n.ch-estat-connexio.ch-online {\n  color: var(--ch-verd);\n}\n\n.ch-estat-connexio.ch-offline {\n  color: var(--ch-gris);\n}\n\n.ch-badge-pendents {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: var(--ch-taronja);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  margin-left: 4px;\n}\n\n/* ---------- Menú lateral ---------- */\n\n.ch-menu-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 30, 40, 0.45);\n  z-index: 30;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.ch-menu {\n  width: min(260px, 80vw);\n  height: 100%;\n  background: #fff;\n  padding: calc(env(safe-area-inset-top, 0px) + 16px) 16px 16px;\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);\n}\n\n.ch-menu-capcalera {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.ch-menu-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: none;\n  background: transparent;\n  padding: 12px 8px;\n  font-size: 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.ch-menu-item-perill {\n  color: var(--ch-vermell);\n}\n\n.ch-menu-item:hover {\n  background: var(--ch-gris-clar);\n}\n\n/* ---------- Contingut / navegació inferior ---------- */\n\n.ch-contingut {\n  flex: 1;\n  padding: 14px 14px calc(env(safe-area-inset-bottom, 0px) + 88px);\n  max-width: 480px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.ch-nav-inferior {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  background: rgba(255, 255, 255, 0.97);\n  border-top: 1px solid var(--ch-gris-clar);\n  padding: 6px 0 calc(env(safe-area-inset-bottom, 0px) + 6px);\n  z-index: 20;\n}\n\n.ch-nav-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  font-size: 11px;\n  color: var(--ch-gris);\n  text-decoration: none;\n  padding: 4px 0;\n}\n\n.ch-nav-item svg {\n  font-size: 18px;\n}\n\n.ch-nav-item.actiu {\n  color: var(--ch-blau);\n  font-weight: 700;\n}\n\n/* ---------- Login ---------- */\n\n.ch-login-pantalla {\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n}\n\n.ch-login-caixa {\n  width: 100%;\n  max-width: 360px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 16px;\n  padding: 32px 24px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  text-align: center;\n}\n\n.ch-login-logo {\n  width: 56px;\n  height: 56px;\n  margin-bottom: 8px;\n}\n\n.ch-login-titol {\n  margin: 0 0 4px;\n  font-size: 22px;\n  color: var(--ch-fosc);\n}\n\n.ch-login-subtitol {\n  margin: 0 0 20px;\n  color: var(--ch-gris);\n  font-size: 13px;\n}\n\n.ch-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  text-align: left;\n}\n\n.ch-camp {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ch-fosc);\n}\n\n.ch-camp input {\n  padding: 11px 12px;\n  border: 1px solid var(--ch-gris-clar);\n  border-radius: 10px;\n  font-size: 15px;\n}\n\n.ch-camp input:focus {\n  outline: none;\n  border-color: var(--ch-blau);\n}\n\n.ch-login-nota {\n  margin-top: 18px;\n  font-size: 11px;\n  color: var(--ch-gris);\n}\n\n/* ---------- Botons ---------- */\n\n.ch-boto-principal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 16px;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  color: #fff;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.ch-boto-principal:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ch-boto-blau {\n  background: var(--ch-blau);\n}\n\n.ch-boto-blau:not(:disabled):hover {\n  background: var(--ch-blau-fosc);\n}\n\n.ch-boto-taronja {\n  background: var(--ch-taronja);\n}\n\n.ch-boto-taronja:not(:disabled):hover {\n  background: var(--ch-taronja-fosc);\n}\n\n.ch-boto-fosc {\n  background: var(--ch-fosc);\n}\n\n.ch-boto-secundari {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--ch-blau);\n  border-radius: 12px;\n  background: transparent;\n  color: var(--ch-blau);\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 8px;\n}\n\n/* ---------- Pantalla Ajuda ---------- */\n\n.ch-boto-tornar {\n  width: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 12px;\n  padding: 8px 14px;\n}\n\n.ch-ajuda-titol {\n  margin-bottom: 12px;\n}\n\n.ch-ajuda-paragraf {\n  margin: 0 0 8px;\n}\n\n.ch-ajuda-paragraf:last-child {\n  margin-bottom: 0;\n}\n\n.ch-ajuda-llista {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 13px;\n  color: var(--ch-gris);\n  line-height: 1.5;\n}\n\n.ch-ajuda-llista li {\n  margin-bottom: 6px;\n}\n\n.ch-ajuda-llista li:last-child {\n  margin-bottom: 0;\n}\n\n/* ---------- Pantalla Inici ---------- */\n\n.ch-salutacio {\n  margin: 4px 0 0;\n  font-size: 15px;\n  color: var(--ch-gris);\n}\n\n.ch-data-llarga {\n  margin: 2px 0 6px;\n  font-size: 13px;\n  color: var(--ch-gris);\n}\n\n.ch-rellotge {\n  margin: 0 0 4px;\n  font-size: 40px;\n  font-weight: 700;\n  color: var(--ch-blau);\n  letter-spacing: 1px;\n}\n\n.ch-rellotge-petit {\n  margin: 0 0 18px;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--ch-blau);\n}\n\n.ch-subestat {\n  margin: 0 0 16px;\n  font-size: 14px;\n  color: var(--ch-gris);\n}\n\n.ch-subestat-blau {\n  color: var(--ch-blau-fosc);\n  font-weight: 600;\n}\n\n.ch-subestat-taronja {\n  color: var(--ch-taronja-fosc);\n  font-weight: 600;\n}\n\n.ch-temps-efectiu {\n  margin: -10px 0 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ch-fosc);\n}\n\n.ch-temps-restant {\n  color: var(--ch-gris);\n  font-weight: 600;\n}\n\n.ch-temps-extra {\n  color: var(--ch-taronja-fosc);\n  font-weight: 600;\n}\n\n.ch-text-retallat {\n  color: var(--ch-taronja-fosc);\n  margin-top: 2px;\n}\n\n.ch-targeta {\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid var(--ch-gris-clar);\n  border-radius: 14px;\n  padding: 12px 14px;\n  margin-bottom: 14px;\n}\n\n.ch-targeta-capcalera {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--ch-fosc);\n  margin-bottom: 8px;\n}\n\n.ch-etiqueta-estat {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 3px 9px;\n  border-radius: 999px;\n}\n\n.ch-etiqueta-oberta {\n  background: rgba(255, 153, 51, 0.15);\n  color: var(--ch-taronja-fosc);\n}\n\n.ch-etiqueta-tancada {\n  background: rgba(0, 153, 204, 0.12);\n  color: var(--ch-blau-fosc);\n}\n\n.ch-fila-event {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 0;\n  border-top: 1px solid var(--ch-gris-clar);\n}\n\n.ch-fila-event:first-of-type {\n  border-top: none;\n}\n\n.ch-icona-cercle {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 14px;\n}\n\n.ch-icona-cercle.ch-icona-petita {\n  width: 26px;\n  height: 26px;\n  font-size: 11px;\n}\n\n.ch-icona-blau {\n  background: var(--ch-blau);\n}\n\n.ch-icona-taronja {\n  background: var(--ch-taronja);\n}\n\n.ch-icona-fosc {\n  background: var(--ch-fosc);\n}\n\n.ch-fila-event-text {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  flex: 1;\n}\n\n.ch-fila-event-text strong {\n  font-size: 14px;\n}\n\n.ch-ubicacio {\n  color: var(--ch-gris);\n  font-size: 11px;\n}\n\n.ch-hora-dreta {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ch-gris);\n  white-space: nowrap;\n}\n\n.ch-text-suau {\n  color: var(--ch-gris);\n  font-size: 13px;\n  margin: 4px 0;\n}\n\n.ch-accio-principal {\n  margin-top: 8px;\n}\n\n.ch-avis-offline {\n  font-size: 12px;\n  color: var(--ch-gris);\n  background: var(--ch-gris-clar);\n  border-radius: 10px;\n  padding: 10px 12px;\n  margin-bottom: 10px;\n}\n\n.ch-avis-pendents {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 12px;\n  color: var(--ch-taronja-fosc);\n  background: rgba(255, 153, 51, 0.12);\n  border-radius: 10px;\n  padding: 10px 12px;\n  margin-bottom: 10px;\n}\n\n.ch-boto-sincronitzar {\n  border: 1px solid var(--ch-taronja);\n  background: #fff;\n  color: var(--ch-taronja-fosc);\n  border-radius: 999px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ch-boto-sincronitzar:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ch-fila-event.ch-pendent {\n  opacity: 0.75;\n}\n\n.ch-etiqueta-pendent {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--ch-taronja-fosc);\n  background: rgba(255, 153, 51, 0.15);\n  border-radius: 999px;\n  padding: 2px 7px;\n  margin-left: 6px;\n  white-space: nowrap;\n}\n\n.ch-etiqueta-error {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--ch-vermell);\n  background: rgba(192, 57, 43, 0.12);\n  border-radius: 999px;\n  padding: 2px 7px;\n  margin-left: 6px;\n  white-space: nowrap;\n}\n\n.ch-avis-error {\n  background: rgba(192, 57, 43, 0.1);\n  color: var(--ch-vermell);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ch-carregant {\n  text-align: center;\n  color: var(--ch-gris);\n  padding: 40px 0;\n  font-size: 14px;\n}\n\n/* ---------- Pantalla Fitxar ---------- */\n\n.ch-pregunta {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 8px 0 2px;\n}\n\n.ch-subpregunta {\n  text-align: center;\n  color: var(--ch-gris);\n  font-size: 13px;\n  margin: 0 0 4px;\n}\n\n.ch-llista-accions {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.ch-accio-principal .ch-boto-principal {\n  min-height: 52px;\n}\n\n.ch-llista-pausa {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 10px 0 16px;\n}\n\n.ch-opcio-pausa {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 1.5px solid var(--ch-gris-clar);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.95);\n  cursor: pointer;\n  text-align: left;\n}\n\n.ch-opcio-pausa.seleccionada {\n  border-color: var(--ch-blau);\n  background: rgba(0, 153, 204, 0.06);\n}\n\n.ch-opcio-pausa.seleccionada svg {\n  color: var(--ch-blau);\n}\n\n.ch-opcio-pausa-text {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  color: var(--ch-gris);\n}\n\n.ch-opcio-pausa-text strong {\n  color: var(--ch-fosc);\n  font-size: 14px;\n}\n\n/* ---------- Pantalla Històric ---------- */\n\n.ch-historic-navegacio {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  margin-bottom: 14px;\n}\n\n.ch-historic-mes {\n  font-weight: 700;\n  font-size: 15px;\n  min-width: 130px;\n  text-align: center;\n}\n\n/* ---------- Pantalla Registres (§8) ---------- */\n\n.ch-registres-periode {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.ch-registres-periode label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: var(--ch-gris);\n  flex: 1;\n}\n\n.ch-registres-periode input {\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: 1px solid var(--ch-gris-clar);\n  font-size: 13px;\n}\n\n.ch-registres-totals {\n  display: flex;\n  justify-content: space-around;\n  gap: 10px;\n}\n\n.ch-registres-total {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.ch-registres-total-valor {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--ch-fosc);\n}\n\n.ch-registres-total-etiqueta {\n  font-size: 11px;\n  color: var(--ch-gris);\n}\n\n.ch-registres-pendent {\n  color: var(--ch-vermell);\n}\n\n.ch-registres-excedent {\n  color: var(--ch-blau);\n}\n\n.ch-registres-dia {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--ch-gris-clar);\n}\n\n.ch-registres-dia:last-child {\n  border-bottom: none;\n}\n\n.ch-registres-dia-data {\n  font-weight: 700;\n  font-size: 13px;\n  color: var(--ch-fosc);\n  min-width: 90px;\n}\n\n.ch-registres-dia-linies {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  font-size: 12px;\n  color: var(--ch-gris);\n}\n\n.ch-registres-saldo-positiu {\n  color: var(--ch-verd);\n  font-weight: 700;\n}\n\n.ch-registres-saldo-negatiu {\n  color: var(--ch-vermell);\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
